import { defineMessages } from 'react-intl';

export default defineMessages({
    // add string ids and default values for localization here
    rvQuoteValidityDays: {
        id: 'quoteandbind.views.rv.quote.Quote Validity Days',
        defaultMessage: 'THIS QUOTE IS VALID FOR {quoteValidityDays} DAYS - COVERAGE IS NOT BOUND UNTIL A BINDER IS ISSUED',
    },
    rvBrokerageCommission: {
        id: 'quoteandbind.views.rv.quote.Brokerage Commission',
        defaultMessage: 'Brokerage Commission',
    },
    rvMimimumRetainedPremium: {
        id: 'quoteandbind.views.rv.quote.Mimimum Retained Premium',
        defaultMessage: 'Mimimum Retained Premium',
    },
    rvMake: {
        id: 'quoteandbind.views.rv.quote.Make',
        defaultMessage: 'Make',
    },
    rvManufacturer: {
        id: 'quoteandbind.views.rv.quote.Manufacturer',
        defaultMessage: 'Manufacturer',
    } 
});
